import { isClient, isServer } from "./global";
import config from "./config";
import { Store } from "redux";
import { ActionsUnion, State } from "./store/types";

type ReduxStore = Store<State, ActionsUnion> & {
  dispatch: {};
};

let store: ReduxStore | null = null;
export function setStore(s: ReduxStore) {
  store = s;
}

export function isEnabled() {
  return isClient() && Boolean((window as any).analytics);
}

if (isEnabled()) {
  window.analytics.load(config.SEGMENT_WRITE_KEY);
}

export const trackEvent: SegmentAnalytics.AnalyticsJS["track"] = (
  eventName: any,
  props?: any,
  options?: SegmentAnalytics.SegmentOpts,
  callback?: () => void
) => {
  if (isServer() || !isEnabled()) {
    return;
  }

  window.analytics.track(eventName, props, options, callback);
};

export const deprecatedTrack = (event: string, properties?: object) => {
  if (isServer() || !isEnabled()) {
    return;
  }

  let intercomId;
  if (store) {
    intercomId = store.getState().auth.intercomId;
  }

  (window.analytics as any).track(event, {
    ...properties,
    intercom_id: intercomId
  });
};

export const identify = (userId: string, traits?: object) => {
  if (isServer() || !isEnabled()) {
    return;
  }

  window.analytics.identify(userId, traits);
};

export const deviceId = () => {
  if (isServer()) {
    return "";
  }

  try {
    if (!window.analytics) {
      return "";
    }

    let user;
    if (window.analytics.user) {
      user = window.analytics.user();
    }

    if (!user) {
      return "";
    }

    return user.anonymousId();
  } catch (err) {
    console.error("unable to get segment anonymous id", err);
    return "";
  }
};

export const reset = () => {
  if (isServer() || !isEnabled()) {
    return;
  }

  window.analytics.reset();
};

interface PageProperties {
  [key: string]: string | number;
}

export const page = (name?: string, properties?: PageProperties) => {
  if (isServer() || !isEnabled()) {
    return;
  }

  let intercomId;
  if (store) {
    intercomId = store.getState().auth.intercomId;
  }

  window.analytics.page(name, { ...properties, intercom_id: intercomId });
};
